import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { firestore } from "firebaseConfig";
import Modal from "./index";
import { getClient } from "services/dietchart"; 
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { UpdateDietChartKeys } from "store/features/dietchart.js";
import { getDietChartConfiguration, userSelector } from "store/features/authSlice";

function SharedDietPlanModalWrapper() {
  const { adminId, dietChartId } = useParams();
  const [open, setOpen] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [client, setClient] = useState(null);
  const [approval, setApproval] = useState(null);
  const [isClientTermsAccepted, setIsClientTermsAccepted] = useState(false);
  const [isConsentProvided,setIsConsentProvided] = useState(false);
  const [showApproval, setShowApproval] = useState(false);
  const dispatch = useDispatch();
  const { dietChartConfiguration } = useSelector(userSelector);

  const navigate = useNavigate();

const approveCheckHandler = (item, value, index) => {
  const chartObj = {
    ...item,
    isApproved: value,
  };

  dispatch(UpdateDietChartKeys({ dietChart: chartObj }))
    .unwrap()
    .then(() => {
      setApproval(value); // update local UI too
      toast.success(value ? "Approved successfully!" : "Approval removed!");
    })
    .catch(() => {
      toast.error("Failed to update approval status. Please try again.");
    });
};

  useEffect(() => {
    async function fetchDietChart() {
      setLoading(true);
      try {
        const ref = doc(firestore, "dietplan", dietChartId);
        const snapshot = await getDoc(ref);
        if (!snapshot.exists()) {
          setNotFound(true);
          setLoading(false);
          return;
        }
        const chart = { ...snapshot.data(), dietChartId: snapshot.id };
         if (chart?.clientId) {
        const clientData = await getClient(chart.clientId);
        setClient(clientData);
        setIsClientTermsAccepted(clientData.isClientTermsAccepted);
        setIsConsentProvided(clientData.isConsentProvided);
      }
        setSelectedItem(chart);
        setApproval(chart?.isApproved ?? false); // set initial approval state
        setLoading(false);
      } catch (e) {
        setNotFound(true);
        setLoading(false);
      }
    }
    fetchDietChart();
  }, [dietChartId]);


  // Fetch approval setting for this adminId
  useEffect(() => {
    if (adminId) {
      dispatch(getDietChartConfiguration({ uid: adminId }));
    }
  }, [adminId, dispatch]);

  useEffect(() => {
    if (typeof dietChartConfiguration === "boolean") {
      setShowApproval(dietChartConfiguration);
    }
  }, [dietChartConfiguration]);

  if (loading) return null;
  if (notFound) return <div style={{padding: 40, textAlign: "center"}}>No diet chart found for this link.</div>;
   const clientTnCStatus = client?.isClientTermsAccepted || client?.isConsentProvided;
  return (
    <>
      <Modal
        open={open}
        client={client}
        handleCloseModal={() => {
          setOpen(false);
          navigate("/login");
        }}
        id={adminId}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        setDietChart={() => {}}
        setSelectedClientv1={() => {}}
        editValue={true}
        mode="edit"
        editHandler={() => {}}
        viewHandler={() => {}}
        approval={approval}
        setApproval={setApproval}
        isSharedLink={true}
        approveCheckHandler={approveCheckHandler}
        clientTnCStatus={clientTnCStatus}
        showApproval={showApproval}
      />
    </>
  );
}

export default SharedDietPlanModalWrapper;
